// ** Initial State
const initialState = {
  orderFilter: {},
};

const orderFilter = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ORDER_FILTER':
      return {
        ...state,
        orderFilter: action.orderFilter,
      };
    // Must return the same reference: redux-persist only rehydrates a slice
    // whose reducer leaves it untouched on REHYDRATE.
    default:
      return state;
  }
};

export default orderFilter;
